import React from 'react';
import Debounce from 'react-debounce-component';
import classnames from 'classnames';
import { PopupDialog, DEFAULT_POPUP_EXIT_TRANSITION } from 'swag-client-common/components/info/popup-dialog/popup-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import { ButtonFontSize, ButtonSize, ButtonTextTransform, ButtonType } from 'swag-client-common/components/ui/button/button';
import classes from './show-error-popup.scss';
export const ShowErrorPopupComponent = ({
  open,
  title,
  errorMessage,
  isButtonShown,
  isLimitedEdition,
  buttonText,
  onButtonClick,
  onClose
}) => {
  const renderContent = () => /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.errorWrapper
  }, errorMessage), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonWrapper
  }, isButtonShown && /*#__PURE__*/React.createElement(Button, {
    textTransform: ButtonTextTransform.none,
    fontSize: ButtonFontSize.small,
    className: classnames(classes.button, {
      [classes.orangeBackground]: isLimitedEdition
    }),
    type: ButtonType.primary,
    size: ButtonSize.large,
    onClick: onButtonClick || onClose
  }, buttonText)));
  const Title = /*#__PURE__*/React.createElement(Debounce, {
    ms: DEFAULT_POPUP_EXIT_TRANSITION
  }, title);
  return /*#__PURE__*/React.createElement(PopupDialog, {
    title: Title,
    dataPopup: "ShowErrorPopup",
    titleClasses: {
      root: classes.header
    },
    titleHeader: classes.header,
    contentClass: classes.contentHeight,
    popupClassName: classes.popup,
    closeClass: isLimitedEdition ? classes.orangeClose : '',
    content: renderContent(),
    onClose: onClose,
    showCloseButton: true,
    open: open
  });
};